<template>
  <section id="main">
    <div class="container">
      <div class="row gtr-200">
        <div class="col-12 about-us">
          <!-- Highlight -->
          <section class="box highlight">
            <header>
              <h2>{{ title }}</h2>
            </header>
            <div class="texto_main nosotros_desc block">
              <!-- Descripcion empresa-->
              <div v-html="legalText"></div>
            </div>
            <div class="back-container">
              <a @click="$router.go(-1)">{{$t('back_label')}}</a>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'LegalPolicy',
  data () {
    return {
      legalText: '',
      title: ''
    }
  },
  created () {
    let filename = this.$route.path
    filename = filename.replace('/legales/', '').toString()
    this.title = filename.replace(new RegExp('-', 'g'), ' ').toUpperCase()
    const jsonInformation = require(`../assets/data/${filename}.json`)
    if (jsonInformation) {
      this.legalText = jsonInformation.text
    }
  }
}
</script>

<style lang="less" scoped>
#main {
  padding-bottom: 4em;
  padding-top: 1em;
}

.texto_main {
  height: 450px;
  overflow-y: scroll;
  text-align: left;
}
.back-container {
  cursor: pointer;
}
</style>
